import { ContextMenu as BaseContextMenu } from '@base-ui/react/context-menu'
import { twMerge } from 'tailwind-merge'
import { ChevronRight } from 'lucide-react'
import { listItemChevron, listItemVariants } from '../../../lib/list-styles'
import type { PartProps } from '../../../lib/part-props'

interface ContextMenuSubmenuTriggerProps extends PartProps<BaseContextMenu.SubmenuTrigger.Props> {
  className?: string
  showIcon?: boolean
}

function ContextMenuSubmenuTrigger({ className, children, showIcon = true, ...props }: ContextMenuSubmenuTriggerProps) {
  return (
    <BaseContextMenu.SubmenuTrigger data-slot="list-item" className={twMerge(listItemVariants(), className)} {...props}>
      {children}
      {showIcon && <ChevronRight data-slot="list-item-chevron" className={listItemChevron} />}
    </BaseContextMenu.SubmenuTrigger>
  )
}

export { ContextMenuSubmenuTrigger }
